<ziro-fieldset-header [legend]="'tkey;shared.dnWizard.dnDetails.extensionDetails.header'">
  <ziro-text [fieldId]="'description'"></ziro-text>
  <ziro-checkbox [fieldId]="'urgentPriority'"></ziro-checkbox>
  <ziro-select [fieldId]="'classOfService'"></ziro-select>
  <ziro-text [fieldId]="'alertingName'"></ziro-text>
  <ziro-select [fieldId]="'routePartition'"></ziro-select>
  <ziro-select [fieldId]="'callPickupGroupName'"></ziro-select>
  <ziro-select [fieldId]="'voicemailProfile'"></ziro-select>
  <ziro-select [fieldId]="'lineGroups'"></ziro-select>
  <ziro-select [fieldId]="'autoAnswer'"></ziro-select>
</ziro-fieldset-header>
